module.exports = __webpack_public_path__ + "img/ic_fast.093348d6.svg";